// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainPane_K0rjo {
  padding: 30px;
  gap: 14px;
  display: grid;
  grid-template-rows: min-content min-content auto min-content;
  height : 100% !important;
}

.mainPane_K0rjo:fullscreen {
  gap: 14px;
  grid-template-rows: min-content min-content auto auto;
}

.noCollection_SbnxN {
  grid-template-rows: min-content auto min-content !important;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/cycleTimeMonitoring/CycleTimeMonitoring.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,4DAA4D;EAC5D,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,qDAAqD;AACvD;;AAEA;EACE,2DAA2D;AAC7D","sourcesContent":[".mainPane {\n  padding: 30px;\n  gap: 14px;\n  display: grid;\n  grid-template-rows: min-content min-content auto min-content;\n  height : 100% !important;\n}\n\n.mainPane:fullscreen {\n  gap: 14px;\n  grid-template-rows: min-content min-content auto auto;\n}\n\n.noCollection {\n  grid-template-rows: min-content auto min-content !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainPane": `mainPane_K0rjo`,
	"noCollection": `noCollection_SbnxN`
};
export default ___CSS_LOADER_EXPORT___;
